import { render, staticRenderFns } from "./AccettazioneSsnEditViewPage.vue?vue&type=template&id=34a8bfee"
import script from "./AccettazioneSsnEditViewPage.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnEditViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports